const toNumber = value => {
  if (value === null || value === undefined || value === '') return NaN;
  return Number(value);
};

/**
 * Picks the concrete class referenced by a product/mix field (e.g. the mix's `consistenceRef`).
 * The product stores a GUID per measurement that points at a concrete-class record; here we resolve
 * it against the entity's concrete classes by `crn` (falling back to `id`). Returns undefined when
 * the product has no ref for that measurement or no matching class exists.
 */
export const findConcreteClassByRef = (concreteClasses = [], concreteClassRef) => {
  if (!concreteClassRef) return undefined;
  return concreteClasses.find(item => item?.crn === concreteClassRef || item?.id === concreteClassRef);
};

/**
 * True when a measured value falls outside the concrete class min/max range.
 * Empty/non-numeric values and missing bounds are treated as "in range" (no warning).
 */
export const isValueOutOfRange = (value, concreteClass) => {
  if (!concreteClass) return false;

  const numericValue = toNumber(value);
  if (Number.isNaN(numericValue)) return false;

  const min = toNumber(concreteClass.minimumValue);
  const max = toNumber(concreteClass.maximumValue);

  if (!Number.isNaN(min) && numericValue < min) return true;
  if (!Number.isNaN(max) && numericValue > max) return true;

  return false;
};
